module.exports = __webpack_public_path__ + "static/rehersal-aab1202ef4a975a1cfd4d859ef30c123.jpg";